import React from "react";
import { Button } from "./Button";
import { faSave } from "@fortawesome/free-solid-svg-icons/faSave";
import { useTranslation } from "../hooks/useTranslation";
import { useLoading } from "../hooks/use-loading";

type Props = {
  validationErrors: any[];
  onClick: () => any;
};

export const SaveFormButton: React.FC<Props> = ({
  validationErrors,
  onClick,
}) => {
  const { t } = useTranslation();
  const { loadings, startLoading, stopLoading } = useLoading({ save: false });
  const handleClick = async () => {
    startLoading("save");
    try {
      await onClick();
    } finally {
      stopLoading("save");
    }
  };

  return (
    <div
      className={"mt-3"}
      style={{
        position: "sticky",
        bottom: 20,
        display: "flex",
        justifyContent: "left",
        zIndex: 2,
      }}
    >
      <Button
        icon={faSave}
        loading={loadings.save}
        color={"bg-blue-500 text-white"}
        className={"hover:bg-blue-400"}
        label={t("save").toString()}
        onClick={handleClick}
      />
      {validationErrors.length > 0 && (
        <div
          className={
            "border flex rounded-2xl justify-center align-items-center ml-1 text-danger text-sm font-medium py-1 px-3 bg-white"
          }
        >
          {t("has_validation_errors")}
        </div>
      )}
    </div>
  );
};
